<template>
  <el-dialog
    :append-to-body="false"
    width="80%"
    title="查看详情"
    center=""
    :visible.sync="visible"
    :before-close="reset"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <div class="fs">
      <el-radio-group v-model="table.params.type" @change="handleTabs">
        <!-- <el-radio-button :label="4">入账明细</el-radio-button> -->
        <el-radio-button :label="1"
          >会员入职退费({{ vip_count }})</el-radio-button
        >
        <el-radio-button :label="2"
          >会员入职补贴({{ allowance_count }})</el-radio-button
        >
      </el-radio-group>
    </div>

    <VTable
      indexLabel="序号"
      :field="field"
      :loading="table.loading"
      :data="table.data"
      :total="table.total"
      :showOverflowTooltip="true"
      :hasPagionation="true"
      :page="table.params.page"
      :pageSize="table.params.count"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    >
      <template v-slot:refund_img="{ row }">
        <el-dropdown
          trigger="click"
          placement="bottom"
          @command="handleCommand($event, row)"
        >
          <span style="cursor: pointer; color: #409eff">
            {{ row.refund_img.length }}张
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item
              v-for="(item, index) in row.refund_img"
              :command="index"
              :key="index"
              >凭证{{ index + 1 }}</el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>
      </template>
    </VTable>
  </el-dialog>
</template>

<script>
import { mixinTable } from "@/mixins/table.js";
import VTable from "@/components/VTable";
export default {
  name: "WealEdit",
  mixins: [mixinTable],
  components: {
    VTable,
  },
  data() {
    return {
      visible: false,
      isChange: false,
      loading: false,
      table: {
        loading: false,
        params: {
          page: 1,
          count: 10,
          type: 1,
        },
        data: [],
        total: 0,
      },
      field: [
        { name: "name", label: "姓名", hidden: false },
        { name: "account", label: "人员账号", hidden: false },
        { name: "entry_date", label: "入职日期", hidden: false },
        { name: "refund_img", label: "入职凭证", hidden: false },
        { name: "apply_time", label: "提交时间", width: "160", hidden: false },
        { name: "check_time", label: "处理时间", width: "160", hidden: false },
      ],
      curRow: null,
      allowance_count: 0,
      vip_count: 0,
    };
  },
  methods: {
    handleTabs() {
      this.table.params.page = 1;
      this.table.data = [];
      this.getTable();
    },
    // 获取详情
    getDetail(row) {
      this.curRow = row;
      this.table.params.type = 1;
      this.getTable();
    },
    getTable() {
      let params_ = {
        ...this.table.params,
        id: this.curRow.id,
      };
      this.table.loading = true;
      this.$http
        .get("/admin/earnest/info", {
          params: params_,
        })
        .then((res) => {
          if (res.code === 1) {
            this.vip_count = res.data.vip_count;
            this.allowance_count = res.data.allowance_count;
            this.table.data = res.data.list;
            this.table.total = res.data.total;
          } else {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    reset(done) {
      done && done();
    },
    toggle(show) {
      this.visible = show;
      !show && this.reset();
    },
    handleCommand(e, row) {
      console.log(e, row, "77");
      window.open(row.refund_img[e]);
    },
  },
};
</script>
<style scoped>
.fs {
  padding: 0 0 20px;
}
</style>
